import { gql } from '@apollo/client';

export const CYCLE_COUNT_ITEM_DETAIL = gql`
    query CycleCountItemDetail($item_id: uuid!, $cycle_count_location_id: uuid!) {
        items_by_pk(item_id: $item_id) {
            item_id
            sku
            description
            quantity
            total_weight
            length
            width
            height
            pallet {
                pallet_id
                pallet_number
                pallet_name
                type
                warehouse_id
                warehouse_location
                warehouse_status
            }
            manifests {
                mapping_id
                manifest {
                    manifest_id
                    manifest_number
                    type
                }
            }
            order {
                order_id
                order_number
                po_number
                reference_id
                dropoff_name
                dropoff_address
                dropoff_city
                dropoff_state
                dropoff_zip
                itemsByOrderId {
                    item_id
                    sku
                    description
                    quantity
                    total_weight
                    length
                    width
                    height
                }
            }
        }
        cycle_count_locations_by_pk(cycle_count_location_id: $cycle_count_location_id) {
            cycle_count_location_id
            warehouse_location
            cycle_count {
                cycle_count_id
                warehouse {
                    location_id
                    location_name
                }
            }
        }
    }
`;
